import { lazyNamed } from 'src/utils/lazyNamed';

export const Creatives = {
  CreativesList: lazyNamed(() => import('./containers/CreativesList'), 'CreativesList'),
  CreativeForm: lazyNamed(() => import('./containers/CreativeForm'), 'CreativeForm'),
};
